import { render } from "./WebinarCard.vue?vue&type=template&id=283079c1&scoped=true"
import script from "./WebinarCard.vue?vue&type=script&lang=js"
export * from "./WebinarCard.vue?vue&type=script&lang=js"

import "./WebinarCard.vue?vue&type=style&index=0&id=283079c1&scoped=true&lang=css"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-283079c1"]])

export default __exports__